import { Component, ViewEncapsulation } from '@angular/core';
import { ReferenceService } from '../../services/reference.service';

@Component({
  selector: 'fs-footer',
  styleUrls: ['./footer.sass'],
  templateUrl: './footer.component.html',
  encapsulation: ViewEncapsulation.None
})

export class FooterComponent {
  urlSlPlusSupport: string;
  urlRecruitment: string;
  urlLegalInfos: string;
  urlTOU: string;

  constructor(private referenceService: ReferenceService) {
    this.urlRecruitment = referenceService.staticReferences.UrlRecruitment;
    this.urlSlPlusSupport = referenceService.staticReferences.UrlSlPlusSupport;
    this.urlLegalInfos = `${referenceService.staticReferences.DuoDomain}/legal-information`;
    this.urlTOU = `${referenceService.staticReferences.DuoDomain}/cgu`;
  }

  showCookies() {
    const windowScope: any = window;
    windowScope.__AVIV_CSNT__?.showBanner();
  }
}
